import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _addressWithContact = { address: '_address' };
var _addToCartRequest = {
    lineItems: '_lineItem',
    customLineItems: '_customLineItem',
};
var _addToCartResponse = { cart: '_cart' };
var _addToCurrentCartRequest = {
    lineItems: '_lineItem',
    customLineItems: '_customLineItem',
};
var _appliedDiscount = { merchantDiscount: '_merchantDiscount' };
var _carrierServiceOption = { shippingOptions: '_shippingOption' };
var _cart = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    lineItems: '_lineItem',
    contactInfo: '_addressWithContact',
};
var _catalogOverrideFields = { physicalProperties: '_physicalProperties' };
var _createCartRequest = {
    cartInfo: '_cart',
    lineItems: '_lineItem',
    customLineItems: '_customLineItem',
};
var _createCartResponse = { cart: '_cart' };
var _createCheckoutFromCurrentCartRequest = {
    shippingAddress: '_address',
    billingAddress: '_address',
};
var _createCheckoutRequest = {
    shippingAddress: '_address',
    billingAddress: '_address',
};
var _createCheckoutResponse = {};
var _customLineItem = {
    physicalProperties: '_physicalProperties',
    subscriptionOptionInfo: '_subscriptionOptionInfo',
    serviceProperties: '_serviceProperties',
};
var _deleteCartRequest = {};
var _deleteCartResponse = {};
var _deleteCurrentCartRequest = {};
var _deliveryLogistics = {
    pickupDetails: '_pickupDetails',
    deliveryTimeSlot: '_deliveryTimeSlot',
};
var _deliveryTimeSlot = {
    from: 'google.protobuf.Timestamp',
    to: 'google.protobuf.Timestamp',
};
var _estimateCurrentCartTotalsRequest = {
    shippingAddress: '_address',
    billingAddress: '_address',
};
var _estimateTotalsRequest = {
    shippingAddress: '_address',
    billingAddress: '_address',
};
var _estimateTotalsResponse = {
    cart: '_cart',
    shippingInfo: '_shippingInformation',
    appliedDiscounts: '_appliedDiscount',
    membershipOptions: '_membershipOptions',
};
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getCartByCheckoutIdRequest = {};
var _getCartByCheckoutIdResponse = { cart: '_cart' };
var _getCartRequest = {};
var _getCartResponse = { cart: '_cart' };
var _getCurrentCartRequest = {};
var _getCurrentCartResponse = { cart: '_cart' };
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _invalidMembership = { membership: '_membership' };
var _lineItem = {
    image: '_image',
    physicalProperties: '_physicalProperties',
    subscriptionOptionInfo: '_subscriptionOptionInfo',
    serviceProperties: '_serviceProperties',
    catalogOverrideFields: '_catalogOverrideFields',
};
var _membership = { expirationDate: 'google.protobuf.Timestamp' };
var _membershipOptions = {
    eligibleMemberships: '_membership',
    invalidMemberships: '_invalidMembership',
};
var _merchantDiscount = { percentage: 'google.protobuf.DoubleValue' };
var _physicalProperties = { weight: 'google.protobuf.DoubleValue' };
var _pickupDetails = { address: '_address' };
var _removeBusinessLocationRequest = {};
var _removeBusinessLocationResponse = { cart: '_cart' };
var _removeCouponFromCurrentCartRequest = {};
var _removeCouponRequest = {};
var _removeCouponResponse = { cart: '_cart' };
var _removeLineItemsFromCurrentCartRequest = {};
var _removeLineItemsRequest = {};
var _removeLineItemsResponse = { cart: '_cart' };
var _selectedCarrierServiceOption = { logistics: '_deliveryLogistics' };
var _serviceProperties = { scheduledDate: 'google.protobuf.Timestamp' };
var _shippingInformation = {
    selectedCarrierServiceOption: '_selectedCarrierServiceOption',
    carrierServiceOptions: '_carrierServiceOption',
};
var _shippingOption = { logistics: '_deliveryLogistics' };
var _subscriptionOptionInfo = {
    subscriptionSettings: '_subscriptionSettings',
};
var _subscriptionSettings = { startDate: 'google.protobuf.Timestamp' };
var _updateCartRequest = {
    cartFieldmask: 'google.protobuf.FieldMask',
    cartInfo: '_cart',
    lineItems: '_lineItem',
    customLineItems: '_customLineItem',
};
var _updateCartResponse = { cart: '_cart' };
var _updateCurrentCartLineItemQuantityRequest = {};
var _updateLineItemsQuantityRequest = {};
var _updateLineItemsQuantityResponse = { cart: '_cart' };
function resolveComWixEcomCartApiV1CartServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/cart',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
        'www.wixgateway.com': [
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
        _: [
            {
                srcPath: '/_api/ecom-cart',
                destPath: '',
            },
            {
                srcPath: '/_api/cart',
                destPath: '',
            },
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/ecom-cart',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/ecom-cart',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/ecom-cart',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/ecom-cart',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/ecom-cart',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixEcomCartApiV1CurrentCartServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/cart',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
        'www.wixgateway.com': [
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
        _: [
            {
                srcPath: '/_api/ecom-cart',
                destPath: '',
            },
            {
                srcPath: '/_api/cart',
                destPath: '',
            },
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/ecom-cart',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/ecom-cart',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/ecom-cart',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/ecom-cart',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/ecom-cart',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/ecom/v1/carts',
                destPath: '/v1/carts',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves the current site visitor's cart.
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function currentCartGetCurrentCart(payload) {
    var _a = serializer(_getCurrentCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCurrentCartResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __currentCartGetCurrentCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'GET',
            methodFqn: 'com.wix.ecom.cart.api.v1.CurrentCartService.GetCurrentCart',
            url: resolveComWixEcomCartApiV1CurrentCartServiceUrl({
                protoPath: '/v1/carts/current',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __currentCartGetCurrentCart.fromReq = fromReq;
    __currentCartGetCurrentCart.__isAmbassador = true;
    return __currentCartGetCurrentCart;
}
/**
 * Updates the current site visitor's cart.
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function updateCurrentCart(payload) {
    var _a = serializer(_updateCartRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _customLineItem: _customLineItem,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCartResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateCurrentCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'PATCH',
            methodFqn: 'com.wix.ecom.cart.api.v1.CurrentCartService.UpdateCurrentCart',
            url: resolveComWixEcomCartApiV1CurrentCartServiceUrl({
                protoPath: '/v1/carts/current',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCurrentCart.fromReq = fromReq;
    __updateCurrentCart.__isAmbassador = true;
    return __updateCurrentCart;
}
/**
 * Adds catalog line items to the current site visitor's cart.
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function addToCurrentCart(payload) {
    var _a = serializer(_addToCurrentCartRequest, {
        _catalogOverrideFields: _catalogOverrideFields,
        _customLineItem: _customLineItem,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addToCartResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __addToCurrentCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CurrentCartService.AddToCurrentCart',
            url: resolveComWixEcomCartApiV1CurrentCartServiceUrl({
                protoPath: '/v1/carts/current/add-to-cart',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addToCurrentCart.fromReq = fromReq;
    __addToCurrentCart.__isAmbassador = true;
    return __addToCurrentCart;
}
/**
 * Removes line items from the current site visitor's cart.
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function removeLineItemsFromCurrentCart(payload) {
    var _a = serializer(_removeLineItemsFromCurrentCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeLineItemsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __removeLineItemsFromCurrentCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CurrentCartService.RemoveLineItemsFromCurrentCart',
            url: resolveComWixEcomCartApiV1CurrentCartServiceUrl({
                protoPath: '/v1/carts/current/remove-line-items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeLineItemsFromCurrentCart.fromReq = fromReq;
    __removeLineItemsFromCurrentCart.__isAmbassador = true;
    return __removeLineItemsFromCurrentCart;
}
/**
 * Creates a checkout from the current site visitor's cart.
 *
 * If a checkout was already created from the current cart,
 * that checkout will be updated with any new information from the cart.
 *
 * >**Note:**
 * >+ `channelType` is a required field.
 * >+ This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function createCheckoutFromCurrentCart(payload) {
    var _a = serializer(_createCheckoutFromCurrentCartRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCheckoutResponse, {}).fromJSON;
    function __createCheckoutFromCurrentCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CurrentCartService.CreateCheckoutFromCurrentCart',
            url: resolveComWixEcomCartApiV1CurrentCartServiceUrl({
                protoPath: '/v1/carts/current/create-checkout',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCheckoutFromCurrentCart.fromReq = fromReq;
    __createCheckoutFromCurrentCart.__isAmbassador = true;
    return __createCheckoutFromCurrentCart;
}
/**
 * Removes the coupon from the current site visitor's cart.
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function removeCouponFromCurrentCart(payload) {
    var _a = serializer(_removeCouponFromCurrentCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeCouponResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __removeCouponFromCurrentCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CurrentCartService.RemoveCouponFromCurrentCart',
            url: resolveComWixEcomCartApiV1CurrentCartServiceUrl({
                protoPath: '/v1/carts/current/remove-coupon',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeCouponFromCurrentCart.fromReq = fromReq;
    __removeCouponFromCurrentCart.__isAmbassador = true;
    return __removeCouponFromCurrentCart;
}
/**
 * Updates the quantity of one or more line items in the current site visitor's cart.
 *
 * This endpoint is only for updating the quantity of line items.
 * To entirely remove a line item from the current cart, use [Remove Line Items From Current Cart](https://dev.wix.com/docs/rest/business-solutions/e-commerce/cart/remove-line-items-from-current-cart).
 * To add a new line item to the current cart, use [Add To Current Cart](https://dev.wix.com/docs/rest/business-solutions/e-commerce/cart/add-to-current-cart).
 *
 * This endpoint checks the amount of stock remaining for this line item.
 * If the specified `quantity` is greater than the remaining stock,
 * then the `quantity` returned in the response is the total amount of remaining stock.
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function updateCurrentCartLineItemQuantity(payload) {
    var _a = serializer(_updateCurrentCartLineItemQuantityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateLineItemsQuantityResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateCurrentCartLineItemQuantity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CurrentCartService.UpdateCurrentCartLineItemQuantity',
            url: resolveComWixEcomCartApiV1CurrentCartServiceUrl({
                protoPath: '/v1/carts/current/update-line-items-quantity',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCurrentCartLineItemQuantity.fromReq = fromReq;
    __updateCurrentCartLineItemQuantity.__isAmbassador = true;
    return __updateCurrentCartLineItemQuantity;
}
/**
 * Estimates the current cart's price totals (including tax),
 * based on a selected carrier service, shipping address, and billing information.
 *
 * >**Note:**
 * >+ Not passing any properties will only estimate the cart items price totals, without considering shipping and billing information.
 * >+ This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function estimateCurrentCartTotals(payload) {
    var _a = serializer(_estimateCurrentCartTotalsRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_estimateTotalsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInformation: _shippingInformation,
        _shippingOption: _shippingOption,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __estimateCurrentCartTotals(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CurrentCartService.EstimateCurrentCartTotals',
            url: resolveComWixEcomCartApiV1CurrentCartServiceUrl({
                protoPath: '/v1/carts/current/estimate-totals',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __estimateCurrentCartTotals.fromReq = fromReq;
    __estimateCurrentCartTotals.__isAmbassador = true;
    return __estimateCurrentCartTotals;
}
/**
 * Deletes the current site visitor's cart.
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function deleteCurrentCart(payload) {
    var _a = serializer(_deleteCurrentCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCartResponse, {}).fromJSON;
    function __deleteCurrentCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'DELETE',
            methodFqn: 'com.wix.ecom.cart.api.v1.CurrentCartService.DeleteCurrentCart',
            url: resolveComWixEcomCartApiV1CurrentCartServiceUrl({
                protoPath: '/v1/carts/current',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCurrentCart.fromReq = fromReq;
    __deleteCurrentCart.__isAmbassador = true;
    return __deleteCurrentCart;
}
/**
 * Creates a cart.
 *
 * >**Note:** When adding catalog line items, the `lineItems.catalogReference.appId` and `lineItems.catalogReference.catalogItemId` fields are required.
 */
export function createCart(payload) {
    var _a = serializer(_createCartRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _customLineItem: _customLineItem,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCartResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __createCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CartService.CreateCart',
            url: resolveComWixEcomCartApiV1CartServiceUrl({
                protoPath: '/v1/carts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCart.fromReq = fromReq;
    __createCart.__isAmbassador = true;
    return __createCart;
}
/** Updates a cart's properties. */
export function updateCart(payload) {
    var _a = serializer(_updateCartRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _customLineItem: _customLineItem,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCartResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'PATCH',
            methodFqn: 'com.wix.ecom.cart.api.v1.CartService.UpdateCart',
            url: resolveComWixEcomCartApiV1CartServiceUrl({
                protoPath: '/v1/carts/{cartInfo.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCart.fromReq = fromReq;
    __updateCart.__isAmbassador = true;
    return __updateCart;
}
/** Retrieves a cart. */
export function getCart(payload) {
    var _a = serializer(_getCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCartResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __getCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'GET',
            methodFqn: 'com.wix.ecom.cart.api.v1.CartService.GetCart',
            url: resolveComWixEcomCartApiV1CartServiceUrl({
                protoPath: '/v1/carts/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCart.fromReq = fromReq;
    __getCart.__isAmbassador = true;
    return __getCart;
}
/** Retrieves the cart associated with a specified checkout. */
export function getCartByCheckoutId(payload) {
    var _a = serializer(_getCartByCheckoutIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCartByCheckoutIdResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __getCartByCheckoutId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'GET',
            methodFqn: 'com.wix.ecom.cart.api.v1.CartService.GetCartByCheckoutId',
            url: resolveComWixEcomCartApiV1CartServiceUrl({
                protoPath: '/v1/carts/by-checkout-id/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCartByCheckoutId.fromReq = fromReq;
    __getCartByCheckoutId.__isAmbassador = true;
    return __getCartByCheckoutId;
}
/**
 * Deprecated. Use CurrentCartService.GetCurrentCart instead.
 * @deprecated It has been replaced with com.wix.ecom.cart.api.v1.CurrentCartService.GetCurrentCart(), and will be removed on 2024-10-31.
 */
export function getCurrentCart(payload) {
    var _a = serializer(_getCurrentCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCurrentCartResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __getCurrentCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'GET',
            methodFqn: 'com.wix.ecom.cart.api.v1.CartService.GetCurrentCart',
            url: resolveComWixEcomCartApiV1CartServiceUrl({
                protoPath: '/v1/carts/get-current',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCurrentCart.fromReq = fromReq;
    __getCurrentCart.__isAmbassador = true;
    return __getCurrentCart;
}
/**
 * Adds [catalog](https://dev.wix.com/api/rest/wix-stores/catalog/ecommerce-integration) line items to a cart.
 *
 * >**Note:** When adding catalog line items to your cart, the `lineItems.catalogReference.appId` and `lineItems.catalogReference.catalogItemId` fields are required.
 */
export function addToCart(payload) {
    var _a = serializer(_addToCartRequest, {
        _catalogOverrideFields: _catalogOverrideFields,
        _customLineItem: _customLineItem,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addToCartResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __addToCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CartService.AddToCart',
            url: resolveComWixEcomCartApiV1CartServiceUrl({
                protoPath: '/v1/carts/{id}/add-to-cart',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addToCart.fromReq = fromReq;
    __addToCart.__isAmbassador = true;
    return __addToCart;
}
/** Removes line items from a cart. */
export function removeLineItems(payload) {
    var _a = serializer(_removeLineItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeLineItemsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __removeLineItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CartService.RemoveLineItems',
            url: resolveComWixEcomCartApiV1CartServiceUrl({
                protoPath: '/v1/carts/{id}/remove-line-items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeLineItems.fromReq = fromReq;
    __removeLineItems.__isAmbassador = true;
    return __removeLineItems;
}
/**
 * Creates a checkout from a cart.
 *
 * If a checkout for the specified cart already exists, that checkout is
 * updated with any new information from the cart.
 *
 * > **Note:** `channelType` is a required field.
 */
export function createCheckout(payload) {
    var _a = serializer(_createCheckoutRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCheckoutResponse, {}).fromJSON;
    function __createCheckout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CartService.CreateCheckout',
            url: resolveComWixEcomCartApiV1CartServiceUrl({
                protoPath: '/v1/carts/{id}/create-checkout',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCheckout.fromReq = fromReq;
    __createCheckout.__isAmbassador = true;
    return __createCheckout;
}
/** Removes the coupon from a cart. */
export function removeCoupon(payload) {
    var _a = serializer(_removeCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeCouponResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __removeCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CartService.RemoveCoupon',
            url: resolveComWixEcomCartApiV1CartServiceUrl({
                protoPath: '/v1/carts/{id}/remove-coupon',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeCoupon.fromReq = fromReq;
    __removeCoupon.__isAmbassador = true;
    return __removeCoupon;
}
/** Updates the quantity of one or more line items in a cart. */
export function updateLineItemsQuantity(payload) {
    var _a = serializer(_updateLineItemsQuantityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateLineItemsQuantityResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateLineItemsQuantity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CartService.UpdateLineItemsQuantity',
            url: resolveComWixEcomCartApiV1CartServiceUrl({
                protoPath: '/v1/carts/{id}/update-line-items-quantity',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateLineItemsQuantity.fromReq = fromReq;
    __updateLineItemsQuantity.__isAmbassador = true;
    return __updateLineItemsQuantity;
}
/**
 * Estimates a cart's price totals (including tax), based on a selected carrier service,
 * shipping address, and billing information.
 */
export function estimateTotals(payload) {
    var _a = serializer(_estimateTotalsRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_estimateTotalsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInformation: _shippingInformation,
        _shippingOption: _shippingOption,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __estimateTotals(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CartService.EstimateTotals',
            url: resolveComWixEcomCartApiV1CartServiceUrl({
                protoPath: '/v1/carts/{id}/estimate-totals',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __estimateTotals.fromReq = fromReq;
    __estimateTotals.__isAmbassador = true;
    return __estimateTotals;
}
/** Deletes a cart. */
export function deleteCart(payload) {
    var _a = serializer(_deleteCartRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCartResponse, {}).fromJSON;
    function __deleteCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'DELETE',
            methodFqn: 'com.wix.ecom.cart.api.v1.CartService.DeleteCart',
            url: resolveComWixEcomCartApiV1CartServiceUrl({
                protoPath: '/v1/carts/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCart.fromReq = fromReq;
    __deleteCart.__isAmbassador = true;
    return __deleteCart;
}
/** Removes the location associated with a cart. */
export function removeBusinessLocation(payload) {
    var _a = serializer(_removeBusinessLocationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeBusinessLocationResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _cart: _cart,
        _catalogOverrideFields: _catalogOverrideFields,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __removeBusinessLocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.cart',
            method: 'POST',
            methodFqn: 'com.wix.ecom.cart.api.v1.CartService.RemoveBusinessLocation',
            url: resolveComWixEcomCartApiV1CartServiceUrl({
                protoPath: '/v1/carts/{id}/remove-business-location',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeBusinessLocation.fromReq = fromReq;
    __removeBusinessLocation.__isAmbassador = true;
    return __removeBusinessLocation;
}
//# sourceMappingURL=http.impl.js.map